<template>
    <div class="container">
        <van-nav-bar
            title="司机订单统计"
            left-text="返回"
            left-arrow
            @click-left="onClickLeft"
        />
        <div class="container">
            <div class="header">
                <div class="selele-date df">
<!--                    <van-dropdown-menu class="norm" active-color="#1989fa">-->
<!--                        <van-dropdown-item class="norm" :value="selectType" @change="onSelectTypeChange"-->
<!--                                           :options="selectTypeOptions"/>-->
<!--                    </van-dropdown-menu>-->
<!--                    <div @click="show = true">-->
<!--                        {{formatedDate}}-->
<!--                    </div>-->
                    <div class="date">
                        <div @click="showSelectStartDate = true" style="margin-bottom: 10px;">开始时间: {{ startDate | formatTime }} ></div>
                        <div @click="showSelectEndDate = true">结束时间: {{ endDate | formatTime }} ></div>
                    </div>
                </div>
                <div class="order-total">
<!--                    <div class="df jcsb">-->
<!--                        <span>总笔数: {{ order.order_count }}笔</span>-->
<!--                        <span>总金额: {{ order.order_amount }}元</span>-->
<!--                    </div>-->
                    <!-- <div div class="df jcsb">
                        <span>微信订单数: {{order.wxpay_order_count}}笔</span>
                        <span>支付宝订单数: {{order.alipay_order_count}}笔</span>
                    </div> -->
                </div>
            </div>
            <div class="order-list">
                <div class="order df" v-for="item in orderList">
                    <div class="order-title">
                        <img class="ico" src="@/assets/qiandai.png"></img>
                        <div class="pdl10">
                            <div class="fs16">司机名:{{ item.duty.name }}</div>
                            <div class="fs14 pdt5">订单数: {{ item.order_total }} 共计:{{ item.amount_total }}元</div>
                            <div class="buses">
                                <span class="busorder" v-for="bus in item.buses">车牌号:{{bus.bus_number_plate}} 订单数:{{bus.order_total}} 共{{bus.amount_total}}元</span>
                            </div>
                        </div>
                    </div>
                    <div class="order-amount">
                        +{{ item.amount_total }}
                    </div>
                </div>
            </div>
            <van-divider v-if="isBottom" contentPosition="center">宝宝也是有底线的</van-divider>

            <van-popup v-model="show" @close="show = false" position="bottom">
            <van-datetime-picker  :type="selectType == 1 ? 'date' : 'year-month'"
                                 @cancel="show = false" @confirm="onInput" :min-date="minDate"
                                 :max-date="maxDate"/>
            </van-popup>

            <van-popup v-model="showSelectStartDate" @close="onClose" position="bottom">
                <van-datetime-picker type="date"

                                     @cancel="onClose" @close="onClose" data-type="start" @confirm="confirm"
                                     :min-date="minDate" :max-date="maxDate"/>
            </van-popup>
            <van-popup v-model="showSelectEndDate" @close="onClose" position="bottom">
                <van-datetime-picker type="date"
                                     v-model="defaultDate"
                                     @cancel="onClose" @close="onClose" data-type="end" @confirm="confirm"
                                     :min-date="minDate" :max-date="maxDate"/>
            </van-popup>

        </div>
        <van-overlay style=" padding-top: 100px;" class="loading-container" :show="loading" @click="loading = false">
            <van-loading size="36px" vertical>加载中...</van-loading>

        </van-overlay>
    </div>
</template>

<script>
var formatNumber = function(n) {
    n = n.toString()
    return n[1] ? n : "0" + n
}
export default {
    name: "BusTotal",
    data(){
        return {
            show: false,
            loading: false,
            showSelectStartDate: false,
            showSelectEndDate: false,
            minDate: new Date(2025, 0, 1),
            defaultDate: new Date(),
            maxDate: new Date(),
            startDate: new Date(new Date().toLocaleDateString()).getTime(),
            endDate: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
            // currentDate: 1652716800000,
            currentDate: +new Date(),
            selectTypeOptions: [{
                text: '按日选择',
                value: 1
            },
                {
                    text: '按月选择',
                    value: 2
                },
            ],
            selectType: 1,
            page: 1,
            orderList: [],
            isBottom:false
        }
    },
    mounted() {
        this.refresh();
        document.title = "司机统计"
    },
    filters: {
        formatTime(time) {
            var date = new Date(time);
            var year = date.getFullYear()
            var month = date.getMonth() + 1
            var day = date.getDate()

            var hour = date.getHours()
            var minute = date.getMinutes()
            var second = date.getSeconds()

            return [year, month, day].map(formatNumber).join('/') + " " + [hour, minute, second].map(formatNumber).join(":");
        },
        formatDate(time) {
            var date = new Date(time);
            var year = date.getFullYear()
            var month = date.getMonth() + 1
            var day = date.getDate()


            return [year, month, day].map(formatNumber).join('/');
        },
    },
    methods: {
        showLoading(){
            this.loading = true;
        },
        closeLoading(){
            this.loading = false;
        },
        onClickLeft(){
            this.$router.back();
        },
        refresh(){
            this.getOrder();
        },
        confirm(value) {
            if (this.showSelectStartDate) {
                this.startDate = +value;
                this.showSelectStartDate = false;
            } else {
                this.endDate = +value + (1000 * 60 * 60 * 24 - 1);
                this.showSelectEndDate = false;
            }
            this.finished = false;
            this.getOrder();
        },
        onClose() {
            this.showSelectEndDate = false;
            this.showSelectStartDate = false;
        },
        getOrder(){
            this.showLoading();
            var searchParams = {
                start_time: parseInt(this.startDate / 1000),
                end_time: parseInt(this.endDate / 1000),
                page: 1,
                size: 30,
            };

            this.$http.get("/order/totalByDriver", {params: searchParams}).then(res =>{
                this.orderList = res.data;
                this.closeLoading();
            });
        },
        onSelectTypeChange(value) {
            this.selectType = value;
            this.refresh();
        },
        onInput(event) {
            this.currentDate = +event;
            this.show = false;
            this.refresh();
        },
        formatDate: function(time){
            var date = new Date(time);
            var year = date.getFullYear()
            var month = date.getMonth() + 1
            var day = date.getDate()


            return [year, month, day].map(formatNumber).join('/');
        },
        formatMonth: function (time) {
            var date = new Date(time);
            var year = date.getFullYear()
            var month = date.getMonth() + 1

            return [year, month].map(formatNumber).join('/');

        }
    },
    computed:{
        formatedDate(){
            if(this.selectType == 1){
                return this.formatDate(this.currentDate);
            }

            return this.formatMonth(this.currentDate);
        }
    }
}
</script>

<style scoped>
.df{
    display: flex;
}
.fs16{
    font-size: 16px;
}
.jcsb{
    justify-content: space-between;
}
.busorder{
    display: block;
    padding-top: 2px;
}
.pdl10{
    padding-left: 10px;
}
.pd10{
    padding: 10px;
}
.van-dropdown-menu__title{
    color: #fff;
}
.container{
    font-size: 14px;
    color: #666;
}

.header{
    color: #666;
    padding: 10px;
    background-color: #5CA3F6;
    color: #fff;
}
.selele-date{
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #fff;
    padding: 10px;
}

.van-dropdown-menu{
    padding-right: 10px;
    flex: 1;
    box-shadow: none;
}


.norm{
    box-shadow: none !important;
    color: #fff  !important;
    background-color: unset !important;
}
.header .van-dropdown-menu__bar{
    height: 25px;
    color: #fff;
    background-color: unset !important;
}
.header .van-dropdown-menu__title{
    color: #fff;
    font-size: 14px;
}
.order-total{
    padding: 0px 10px;
    padding-top: 10px;
}
.order-total view{
    padding: 5px 0px;
    font-size: 16px;
}
.ico{
    width: 45px;
    height: 45px;
}
.order-list{
    background-color: #fff;
    padding: 10px;
    box-sizing: border-box;
    border-radius: 10px;
}
.order{
    border-bottom: 1px solid #eee;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
}
.order-title{
    display: flex;
}
.order-title view{
    display: flex;
    flex-direction: column;
}
.order-amount{
    font-size: 18px;
    color:#FF6633;
}

</style>



// WEBPACK FOOTER //
// src/components/DriverTotal.vue